export default __webpack_public_path__ + "static/media/acceleX.1cdf0fc2.svg";